export const authPath = {
  /* inject path */
  RESET_NEW_PASSWORD: '/auth/reset-new-password',
  SIGN_IN: '/auth/sign-in',
  REDIRECT_SIGN_IN: '/auth/sign-in/redirect',
  FORGOT_PASSWORD: '/auth/forgot-password',
  SECOND_AUTHENTICATION: '/auth/second-auth',
  BLOCKED: '/auth/blocked',
};
